export const THEME_STORAGE_KEY = 'pieve-theme';
const PREFERENCES = ['light', 'dark', 'system'];

/**
 * Reads the theme preference: a `theme` query parameter wins (useful for screenshots and
 * links), then the saved choice, then "system".
 */
export const readThemePreference = ({ search, storage }) => {
  const fromQuery = new URLSearchParams(search).get('theme');
  if (PREFERENCES.includes(fromQuery)) {
    return fromQuery;
  }
  let stored = null;
  try {
    stored = storage.getItem(THEME_STORAGE_KEY);
  } catch {
    stored = null;
  }
  if (PREFERENCES.includes(stored)) {
    return stored;
  }
  return 'system';
};
